export { default } from './InstallationSummaryConnector';
